import config from 'config'

const authApi = `${config.apiHost}/oem-auth`
const customerApi = `${config.apiHost}/oem-customer`

export default {
    // 企业微信侧边栏参数相关
    wWorkAgents: {
        url: `${authApi}/api/agents`,
        type: 'GET',
    },
    task: {
        url: `${customerApi}/api/tasks/{id}`,
        type: 'GET',
    },
    usersActions: {
        url: `${authApi}/api/users/actions`,
        type: 'POST',
    },
}
